import { observable, action, computed } from 'mobx';
var MobileDetect = require('mobile-detect');

class SiteStore {
  @observable screenWidth;
  @observable screenHeight;
  @observable isLoading = false;
  @observable submenuTop;

  constructor() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions.bind(this));
  }

  updateWindowDimensions() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  get isMobile() {
    const md = new MobileDetect(window.navigator.userAgent);
    return md.mobile();
  }

  lockScroll() {
    document.body.className = 'overflowHidden';
    document.body.parentNode.className = 'overflowHidden';
  }

  unlockScroll() {
    document.body.className = '';
    document.body.parentNode.className = '';
  }

  @action setSubmenuTop(top) {
    this.submenuTop = top;
  }

  @action load() {
    this.isLoading = true;
  }

  @action loaded() {
    this.isLoading = false;
  }

  @computed get isMobileResolution() {
    return this.screenWidth <= 997;
  }
}

export default new SiteStore();



// WEBPACK FOOTER //
// ./src/stores/SiteStore.js